/**
 * Created by luka on 28.02.2018.
 */
import React from 'react';

import {colors} from "../styles/colors";
import {CircularProgress} from 'material-ui/Progress';
import Button from 'material-ui/Button';
import {LinearProgress} from "material-ui";
import moment from 'moment';
export default class WorkoutLinearProgress extends React.PureComponent {

    convertCentToAmount(cents) {
        return Math.trunc(cents / 100);
    }

    getPayoutAmount(){
        const total = this.props.total;
        const period = this.props.period;
        const extraPayout1 = this.props.extraPayout1;
        const extraPayout2 = this.props.extraPayout2;
        const extraPayout3 = this.props.extraPayout3;
        const extraPayout4 = this.props.extraPayout4;
        if (period === 1) {
            return this.convertCentToAmount(total * period + extraPayout1);
        } else if (period === 2) {
            return this.convertCentToAmount(total * period + extraPayout2);
        } else if (period === 3) {
            return this.convertCentToAmount(total * period + extraPayout3);
        } else if (period === 4) {
            return this.convertCentToAmount(total * period + extraPayout4);
        } else {
            return this.convertCentToAmount(total * period + extraPayout4);
        }
    }

    getDaysUntilPayout() {
        const nextPayoutDate = moment(this.props.nextPayout);

        if (nextPayoutDate) {
            return Math.abs(moment().diff(nextPayoutDate, 'days'));
        } else {
            return 0;
        }
    }

    getProgress() {
        const nextPayoutDate = moment(this.props.nextPayout);
        const periodBegin = moment(this.props.periodBegin);

        if (nextPayoutDate && periodBegin) {
            const totalDays = Math.abs(periodBegin.diff(nextPayoutDate, 'days')); //TODO
            const diff = Math.abs(moment().diff(nextPayoutDate, 'days'));
            const absolvedDays = totalDays - diff;

            return (absolvedDays * 100) / totalDays;
        } else {
            return 0;
        }
    }

    render() {
        const {t} = this.props;
        return (
            <div style={styles.wrapper}>
                <h4 style={styles.payoutDescription}>{t('overview:nextPayout', {amount: this.getPayoutAmount(), count: this.getDaysUntilPayout()})}</h4>

                <LinearProgress color="primary" variant="determinate"
                                value={this.getProgress()}/>
            </div>
        )
    }
}

const styles = ({
    wrapper: {
        position: 'relative',
    },
    payoutDescription: {
        color: colors.primaryColor,
        marginBottom: 4
    },
});




// WEBPACK FOOTER //
// ./src/components/WorkoutProgress.js